(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fss-cart"]) return;
  try {
    
if (!customElements.get('fss-cart-normalizer')) customElements.define('fss-cart-normalizer', class extends HTMLElement {
  connectedCallback() {
    if (this.started || !this.querySelector('[data-quantity-fix]')) return;
    this.started = true;
    this.normalize();
  }
  async normalize() {
    const form = this.querySelector('form');
    const status = this.querySelector('[data-quantity-fix]');
    const productIds = new Set([...this.querySelectorAll('[data-single-copy-product]')].map(row => row.dataset.singleCopyProduct));
    try {
      const response = await fetch(form.dataset.updateUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({updates: [...form.querySelectorAll('[name="updates[]"]')].map(input => Number(input.value))})
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
      for (const productId of productIds) {
        const count = cart.items.filter(item => String(item.product_id) === productId).reduce((sum, item) => sum + item.quantity, 0);
        if (count !== 1) throw new Error('Duplicate remains');
      }
      window.location.replace(form.action);
    } catch (_) {
      status.textContent = status.dataset.error;
      status.setAttribute('role', 'alert');
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fss-library"]) return;
  try {
    
if (!customElements.get('fss-library')) {
  customElements.define('fss-library', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.list = this.querySelector('[data-library-list]');
      this.rows = [...this.list.querySelectorAll('[data-sound-id]')];
      this.limit = 24;
      this.querySelector('.fss-library-toolbar').hidden = false;
      this.querySelector('[data-library-search]').addEventListener('input', () => { this.limit = 24; this.filter(); });
      this.querySelector('[data-library-more]').addEventListener('click', () => { this.limit += 24; this.filter(); });
      this.filter();
      this.loadPurchases();
      this.onPageShow = event => { if (event.persisted) window.location.reload(); };
      window.addEventListener('pageshow', this.onPageShow);
    }
    disconnectedCallback() {
      this.controller?.abort();
      window.removeEventListener('pageshow', this.onPageShow);
    }
    filter() {
      const query = this.querySelector('[data-library-search]').value.trim().toLocaleLowerCase();
      let matches = 0;
      this.rows.forEach(row => { const match = row.dataset.soundTitle.toLocaleLowerCase().includes(query); row.hidden = !match || ++matches > this.limit; });
      this.querySelector('[data-library-count]').textContent = `${matches} ${matches === 1 ? this.dataset.countOne : this.dataset.countLabel}`;
      this.querySelector('[data-library-empty]').hidden = this.rows.length > 0;
      this.querySelector('[data-library-no-results]').hidden = !this.rows.length || matches > 0;
      this.querySelector('[data-library-more]').hidden = matches <= this.limit;
    }
    async loadPurchases() {
      if (this.dataset.bundle === 'true') return;
      const status = this.querySelector('[data-library-status]');
      const pageCount = Number(this.dataset.pages);
      const currentPage = Number(this.dataset.page);
      if (pageCount <= 1) return;
      this.controller = new AbortController();
      status.textContent = this.dataset.loading;
      const base = new URL(window.location.href);
      base.searchParams.set('view', 'my-sounds');
      try {
        for (let page = 1; page <= pageCount; page++) {
          if (page === currentPage) continue;
          const url = new URL(base);
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
          if (!response.ok) throw new Error('Purchase check failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const library = doc.querySelector('fss-library');
          if (!library || Number(library.dataset.page) !== page) throw new Error('Sign-in or purchase check failed');
          const ids = new Set(this.rows.map(row => row.dataset.soundId));
          for (const row of library.querySelectorAll('[data-sound-id]')) {
            if (!ids.has(row.dataset.soundId)) { ids.add(row.dataset.soundId); this.list.append(document.importNode(row, true)); }
          }
          this.rows = [...this.list.querySelectorAll('[data-sound-id]')].sort((a, b) => a.dataset.soundTitle.localeCompare(b.dataset.soundTitle));
          this.list.append(...this.rows);
          this.filter();
          if (library.dataset.bundle === 'true') {
            this.dataset.bundle = 'true';
            this.querySelector('[data-library-access]').textContent = this.dataset.bundleLabel;
            break;
          }
        }
        this.querySelector('[data-library-order-pages]').hidden = true;
        status.textContent = this.dataset.ready;
      } catch (error) {
        if (error.name !== 'AbortError') status.textContent = this.dataset.loadError;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fss-shell"]) return;
  try {
    
  (() => {
    const interfaceData = () => document.getElementById('FssInterface')?.dataset || {};
    const limitedConnection = () => navigator.connection?.saveData || ['slow-2g', '2g'].includes(navigator.connection?.effectiveType);
    let preparingPlayer;
    const previewObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { previewObserver.unobserve(entry.target); entry.target.preparePreview?.(); }
      });
    }) : null;
    class FssAudio extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        const audio = this.querySelector('audio');
        const button = this.querySelector('button');
        if (!audio || !button) return;
        this.dataset.enhanced = 'true'; button.hidden = false;
        const error = this.querySelector('.fss-audio-error');
        const time = this.querySelector('.fss-time');
        const seek = this.querySelector('.fss-seek');
        if (seek) seek.hidden = false;
        const format = seconds => Number.isFinite(seconds) ? `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}` : '—';
        const setPlaying = playing => {
          this.toggleAttribute('data-playing', playing);
          button.setAttribute('aria-pressed', String(playing));
          button.setAttribute('aria-label', `${playing ? interfaceData().pause : interfaceData().play} ${this.dataset.title}`);
        };
        const sources = Array.from(audio.querySelectorAll('source'));
        const failedSources = new Set();
        let failed = false;
        let requested = false;
        let preparationTimeout;
        const prioritize = active => {
          this.toggleAttribute('data-audio-priority', active);
          document.dispatchEvent(new Event('fss-audio-priority'));
        };
        const finishPreparation = () => {
          clearTimeout(preparationTimeout);
          if (preparingPlayer === this) preparingPlayer = null;
          if (audio.paused) prioritize(false);
        };
        this.cancelPreparation = () => {
          if (preparingPlayer !== this) return;
          finishPreparation();
          if (audio.paused && !requested) { audio.preload = 'none'; audio.load(); }
        };
        this.preparePreview = () => {
          if (limitedConnection() || requested || !audio.paused || audio.readyState > 0) return;
          if (Array.from(document.querySelectorAll('fss-audio audio')).some(other => !other.paused)) return;
          if (preparingPlayer === this) return;
          preparingPlayer?.cancelPreparation();
          preparingPlayer = this;
          failed = false; failedSources.clear();
          prioritize(true);
          audio.preload = 'metadata';
          audio.load();
          preparationTimeout = setTimeout(() => this.cancelPreparation(), 5000);
        };
        const showError = () => {
          failed = true;
          finishPreparation();
          audio.pause();
          error.hidden = !requested;
          prioritize(false);
          setPlaying(false);
        };
        button.addEventListener('pointerenter', () => this.preparePreview());
        button.addEventListener('focus', () => this.preparePreview());
        if (this.dataset.preload === 'metadata' && previewObserver && !limitedConnection()) previewObserver.observe(this);
        button.addEventListener('click', async () => {
          if (!audio.paused) { audio.pause(); return; }
          requested = true;
          preparingPlayer?.cancelPreparation();
          error.hidden = true;
          if (failed || audio.error) { failed = false; failedSources.clear(); audio.load(); }
          prioritize(true);
          try { await audio.play(); } catch (reason) {
            if (reason.name !== 'AbortError') showError();
            else if (audio.paused) { prioritize(false); setPlaying(false); }
          }
        });
        audio.addEventListener('play', () => {
          document.querySelectorAll('fss-audio audio').forEach(other => { if (other !== audio) other.pause(); });
          prioritize(true);
          setPlaying(true);
        });
        audio.addEventListener('pause', () => { prioritize(false); setPlaying(false); });
        audio.addEventListener('ended', () => { prioritize(false); setPlaying(false); time.textContent = format(audio.duration); });
        const updateTime = () => {
          const duration = audio.duration;
          this.querySelectorAll("fss-waveform i").forEach((bar, index) => bar.classList.toggle("is-played", Number.isFinite(duration) && duration > 0 && index / 48 < audio.currentTime / duration));
          time.textContent = `${format(audio.currentTime)} / ${format(duration)}`;
          if (seek && Number.isFinite(duration) && duration > 0) {
            seek.disabled = false;
            seek.max = String(duration);
            seek.value = String(audio.currentTime);
            seek.setAttribute('aria-valuetext', `${format(audio.currentTime)} / ${format(duration)}`);
          }
        };
        audio.addEventListener('loadedmetadata', () => { finishPreparation(); updateTime(); });
        audio.addEventListener('timeupdate', updateTime);
        seek?.addEventListener('input', () => { if (Number.isFinite(audio.duration)) audio.currentTime = Number(seek.value); });
        audio.addEventListener('error', showError);
        sources.forEach(source => source.addEventListener('error', () => {
          failedSources.add(source);
          if (failedSources.size === sources.length) showError();
        }));
      }
      disconnectedCallback() {
        previewObserver?.unobserve(this);
        this.cancelPreparation?.();
        this.querySelector('audio')?.pause();
        this.removeAttribute('data-audio-priority');
        document.dispatchEvent(new Event('fss-audio-priority'));
      }
    }
    if (!customElements.get('fss-audio')) customElements.define('fss-audio', FssAudio);
    const key = 'fss-preview-basket-v1';
    const validLine = line => line && /^\d+$/.test(String(line.id)) && typeof line.title === 'string' && typeof line.url === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/.test(line.url) && Number.isSafeInteger(line.price) && line.price > 0 && line.price < 10000000;
    const readBasket = () => {
      try { const value = JSON.parse(sessionStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(validLine).slice(0, 100) : []; } catch { return []; }
    };
    const money = cents => `${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100)} USD`;
    const renderBasket = () => {
      if (interfaceData().review !== 'true') return;
      const lines = readBasket();
      document.querySelectorAll('[data-fss-review-count]').forEach(el => { el.textContent = String(lines.length); });
      document.querySelectorAll('[data-fss-review-add]').forEach(el => { el.disabled = false; });
      const holder = document.querySelector('[data-fss-review-lines]');
      if (!holder) return;
      holder.replaceChildren();
      lines.forEach(line => {
        const row = document.createElement('div'); row.className = 'fss-cart-row';
        const link = document.createElement('a'); link.href = line.url; link.textContent = line.title;
        const price = document.createElement('strong'); price.textContent = money(line.price);
        const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.fssReviewRemove = String(line.id); remove.textContent = interfaceData().remove; remove.setAttribute('aria-label', `${interfaceData().remove} ${line.title}`);
        row.append(link, price, remove); holder.append(row);
      });
      document.querySelector('[data-fss-review-empty]').hidden = lines.length > 0;
      document.querySelector('[data-fss-review-total]').textContent = money(lines.reduce((sum, line) => sum + line.price, 0));
    };
    const notify = text => {
      const toast = document.querySelector('.fss-toast');
      if (!toast) return;
      toast.querySelector('[data-fss-toast-message]').textContent = text; toast.hidden = false;
    };
    document.addEventListener('click', event => {
      const add = event.target.closest('[data-fss-review-add]');
      const remove = event.target.closest('[data-fss-review-remove]');
      if (event.target.closest('[data-fss-toast-close]')) document.querySelector('.fss-toast').hidden = true;
      if ((!add && !remove) || interfaceData().review !== 'true') return;
      let lines = readBasket();
      if (add) {
        const line = {id:add.dataset.productId, title:add.dataset.title, url:add.dataset.url, price:Number(add.dataset.price)};
        if (!validLine(line)) return;
        lines = lines.filter(item => item.id !== line.id); lines.push(line);
      } else lines = lines.filter(line => line.id !== remove.dataset.fssReviewRemove);
      try { sessionStorage.setItem(key, JSON.stringify(lines)); renderBasket(); if (add) notify(interfaceData().added); }
      catch { notify(interfaceData().storageError); }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderBasket); else renderBasket();
    document.addEventListener('shopify:section:load', renderBasket);
    window.addEventListener('pageshow', renderBasket);
    document.addEventListener('keydown', event => { if (event.key === 'Escape') { document.querySelectorAll('.fss-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); const toast = document.querySelector('.fss-toast'); if (toast) toast.hidden = true; } });
  })();
if(!customElements.get('fss-pack-content'))customElements.define('fss-pack-content',class extends HTMLElement{connectedCallback(){this.querySelectorAll('.fss-original-description h4').forEach(heading=>{if(!heading.textContent.trim()&&!heading.querySelector('img,video,iframe'))heading.hidden=true;});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
